var _defs, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqurepocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-144,.cls-143{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-144{stroke-width:3px;}.cls-143{stroke-dasharray:3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 77,
    y: 174.38,
    width: 269,
    height: 243.62
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 80,
    y: 177.38,
    width: 263,
    height: 237.62
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 77,
    y: 122.38,
    width: 269,
    height: 52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 80,
    y: 125.38,
    width: 263,
    height: 46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqurepocket01);
export default __webpack_public_path__ + "static/media/SQURE POCKET-01.7a5e9698cc3cf0cb76b4ea65b0a2d5a0.svg";
export { ForwardRef as ReactComponent };